"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSN_REGEX = void 0;
exports.SSN_REGEX = /^\d{9}$/;
//# sourceMappingURL=ssn.js.map